import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

export default function ParentCompany({
                                          contextPath = "",
                                          openSheet,
                                          height = 575,
                                            }) {
    const [rows, setRows] = useState([]);
    const [q, setQ] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        let mounted = true;
        (async () => {
            setLoading(true);
            setErr("");
            const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` };
            try {
                const { data } = await axios.get(`${contextPath}/parent-companies/structure`, { headers });
                if (mounted) setRows(Array.isArray(data) ? data : []);
            } catch (e) {
                console.error(e);
                if (mounted) setErr("Failed to load parent companies.");
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => { mounted = false; };
    }, [contextPath]);

    const filtered = useMemo(() => {
        const s = (q || "").trim().toLowerCase();
        if (!s) return rows;
        return rows.filter(r => {
            const pn = (r?.parentCompany?.name || "").toLowerCase();
            const vs = (r?.vendors || []).some(v => (v.name || "").toLowerCase().includes(s));
            return pn.includes(s) || vs;
        });
    }, [rows, q]);

    return (
        <div className="w-full p-4">
            <div className="mb-3 flex items-center gap-2">
                <h1 className="text-2xl font-semibold">Parent Companies</h1>
                <input
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Filter by parent or vendor…"
                    className="ml-auto border rounded-md px-3 py-1 text-sm w-72"
                />
            </div>

                <div
                    className="w-full overflow-auto rounded-md border border-gray-200 bg-white"
                    style={{ height }}
                >

                <div className="grid grid-cols-2 bg-gray-50 border-b">
                    <div className="px-3 py-2 font-medium">Parent</div>
                    <div className="px-3 py-2 font-medium">Vendor</div>
                </div>

                {loading && <div className="p-4 text-sm text-gray-600">Loading…</div>}
                {err && !loading && <div className="p-4 text-sm text-red-600">{err}</div>}

                {!loading && !err && filtered.length === 0 && (
                    <div className="p-4 text-sm text-gray-600">No results.</div>
                )}

                {!loading && !err && filtered.map((block) => (
                    <div key={block.parentCompany.id} className="grid grid-cols-2 border-b last:border-0">
                        <div className="px-3 py-2">
                            {block.parentVendorId ? (
                                <button
                                    className="text-[#25408f] hover:underline"
                                    title="Open Vendor Tearsheet"
                                    onClick={() => openSheet?.("vendor", block.parentVendorId , block.parentVendorName  || `Vendor #${block.parentVendorId }`)}
                                >
                                    {block.parentCompany.name}
                                </button>
                            ) : (
                                <span>{block.parentCompany.name}</span>
                            )}
                        </div>
                        <div className="px-3 py-2 leading-6">
                            {(block.vendors || []).map(v => (
                                <div key={v.id}>
                                    <button
                                        className="text-[#25408f] hover:underline"
                                        title="Open Vendor Tearsheet"
                                        onClick={() => openSheet?.("vendor", v.id, v.name || `Vendor #${v.id}`)}
                                    >
                                        {v.name}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
